import { React, PT, WithData } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Dimmer, Loader, Segment, Modal, Table, Button, Header, Icon, Input, TextArea, Form, Divider, Checkbox } from 'semantic-ui-react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Auth, Nav } from '../../components';
import { fetch } from '../../../client/lib/fetch';
import { Role } from '../../roles';

const theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

class BaseQueue extends React.Component {
  state = {
  }

  getMessages = () => {
    this.setState({ loading: true }, async () => {
      const { fetchCount, noRequeue } = this.state;
      const { match: { params: { queueName } } } = this.props;
      const { body } = await fetch(`/system/queues/get/${queueName}`, {
        count: fetchCount || 100,
        noRequeue: noRequeue ? 'do-not-requeue' : '',
      });
      this.setState({ messages: body, original: body, loading: false }, () => {
        const { fetch: fetchFn } = this.props;
        fetchFn();
      });
    });
  }

  shovelMessages = () => {
    this.setState({ loading: true }, async () => {
      const { match: { params: { queueName } } } = this.props;
      await fetch(`/system/queues/shovel/${queueName}`, {
        to: queueName.replace(/\.rejected\.q$/, '').replace(/\.unhandled\.q$/, ''),
      });
      this.setState({ modal: null, loading: false }, () => {
        const { fetch: fetchFn } = this.props;
        fetchFn();
      });
    });
  }

  applyFilter = () => {
    try {
      const { original, filterFn } = this.state;
      // eslint-disable-next-line no-new-func
      const fn = new Function('m', 'ix', filterFn);
      const messages = original.filter(fn);
      this.setState({ messages });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  getAndDeleteChanged = (e, { checked }) => {
    this.setState({ noRequeue: checked });
  }

  render() {
    const { data, match, loading } = this.props;
    const { messages, original, loading: stateLoad, modal } = this.state;
    let mainExchange;

    if (match.params.queueName && (match.params.queueName.endsWith('.rejected.q')
      || match.params.queueName.endsWith('.unhandled.q'))) {
      mainExchange = match.params.queueName
        .replace(/\.rejected\.q$/, '')
        .replace(/\.unhandled\.q$/, '');
    }

    return (
      <Auth forRoles="admin.superuser,admin.system.queues">
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading || stateLoad}>
            <Dimmer active={loading || stateLoad}>
              <Loader />
            </Dimmer>
            <div>
              <h1>
                {match.params.queueName}
                <a
                  href={`https://github.com/gas-buddy/wiki/wiki/queue-${match.params.queueName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="question circle" />
                </a>
              </h1>
              <Table compact>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>State</Table.Cell>
                    <Table.Cell>{data.state}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Messages Ready</Table.Cell>
                    <Table.Cell>{data.messages_ready}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Messages In Process</Table.Cell>
                    <Table.Cell>{data.messages_unacknowledged}</Table.Cell>
                  </Table.Row>
                  {mainExchange
                    && (
                    <Table.Row>
                      <Table.Cell>Related Queue</Table.Cell>
                      <Table.Cell>
                        <a href={`/system/queues/${mainExchange}.q`}>
                          {mainExchange}
                          .q
                        </a>
                      </Table.Cell>
                    </Table.Row>
                    )
                  }
                </Table.Body>
              </Table>

              {mainExchange
                && (
                <Modal
                  basic
                  open={modal === 'shovel'}
                  trigger={(
                    <Button onClick={() => this.setState({ modal: 'shovel' })}>
                      Shovel to
                      {' '}
                      {mainExchange}
                    </Button>
                  )}
                >
                  <Header icon="attention" content="Are you sure?" />
                  <Modal.Content>
                    <p>
                      Are you sure you want to move these messages to
                      <b>{mainExchange}</b>
                      ?
                    </p>
                  </Modal.Content>
                  <Modal.Actions>
                    <Button basic color="grey" inverted onClick={() => this.setModal(null)}>
                      <Icon name="minus" />
                      {' '}
                      Leave Messages Alone
                    </Button>
                    <Button basic color="red" onClick={this.shovelMessages}>
                      <Icon name="copy" />
                      {' '}
                      Move Messages
                    </Button>
                  </Modal.Actions>
                </Modal>
                )
              }
              <Input placeholder="100" onChange={(d, v) => this.setState({ fetchCount: v.value })}>
                <Button style={{ marginRight: -5 }} onClick={this.getMessages}>Get</Button>
                <input size="5" />
                <Button style={{ marginLeft: -5 }} onClick={this.getMessages}>Messages</Button>
              </Input>

              <Auth forRoles={[Role.Superuser]} hideUnauthorized>
                <span style={{ marginLeft: 50 }}>
                  <Checkbox label="Get and DELETE Messages" onChange={this.getAndDeleteChanged} />
                </span>
              </Auth>

              {original
                && (
                <Segment>
                  <Form>
                    <p>
Filter function (signature: (m, ix) =&gt;
                      {'{'}
                      {' '}
&hellip;your code here&hellip;
                      {'}'}
)
                    </p>
                    <TextArea
                      rows={3}
                      onBlur={this.applyFilter}
                      onChange={(e, v) => { this.state.filterFn = v.value; }}
                    />
                  </Form>
                  <p>
                    <b>{messages.length}</b>
                    {' '}
matches
                  </p>
                  {messages.map(m => (
                    <div>
                      <div style={{ float: 'right' }}>
                        <CopyToClipboard text={JSON.stringify(m?.body)}>
                          <Icon name="copy" />
                        </CopyToClipboard>
                      </div>
                      <div style={{ marginRight: 20 }}>
                        <JSONTree
                          invertTheme
                          hideRoot
                          shouldExpandNode={() => true}
                          data={m || {}}
                          theme={theme}
                        />
                      </div>
                      <Divider />
                    </div>
                  ))}
                </Segment>
                )
              }
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

BaseQueue.propTypes = {
  data: PT.shape({
    queue: PT.shape({
      name: PT.string,
    }),
  }),
  fetch: PT.func.isRequired,
  match: PT.shape({
    params: PT.shape({
      queueName: PT.string.isRequired,
    }).isRequired,
  }).isRequired,
  loading: PT.bool,
};

BaseQueue.defaultProps = { loading: false, data: {} };

export const Queue = ({ match }) => (
  <WithData url={`/system/queues/${match.params.queueName}`}>
    <BaseQueue match={match} />
  </WithData>
);

Queue.propTypes = {
  match: PT.shape({
    params: PT.shape({
      queueName: PT.string.isRequired,
    }).isRequired,
  }).isRequired,
};
